<app-flight-search-loader
  *ngIf="loading"
  [origin]="flightForm.get('from')?.value || flightForm.get('ui_From')?.value"
  [destination]="flightForm.get('to')?.value || flightForm.get('ui_To')?.value"
  [tripType]="flightForm.get('tripType')?.value || 'oneway'"
></app-flight-search-loader>

<div class="tab-content" id="pills-tabContent">
  <div class="tab-pane fade show active" id="pills-1" role="tabpanel" aria-labelledby="pills-tab-1" tabindex="0">
    <div class="flight-search ft-group">
      <div class="search-form">
        <form [formGroup]="flightForm" (ngSubmit)="onSubmit()">
          <!-- flight type -->
          <div class="flight-type">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" checked value="oneway" formControlName="tripType"
                id="flight-type1" (click)="onFlightTypeChange('oneway')">
              <label class="form-check-label" for="flight-type1">{{'One Way' | lang}}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" value="roundtrip" formControlName="tripType"
                id="flight-type2" (click)="onFlightTypeChange('roundtrip')">
              <label class="form-check-label" for="flight-type2">{{'Roundtrip' | lang}}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" value="multicity" formControlName="tripType"
                id="flight-type3" (click)="onFlightTypeChange('multicity')">
              <label class="form-check-label" for="flight-type3">{{'Multi City' | lang}}</label>
            </div>
          </div>
          <!-- flight type end -->
          <!-- flight search -->
          <div class="flight-search-wrapper">
            <div class="flight-search-content">
              <!-- flight search content -->
              <div class="flight-search-item">
                <div class="row" *ngIf="tripType != 'multicity'">
                  <div class="col-xl-3 col-lg-6 col-md-6">
                    <div class="form-group">
                      <label class="mb-0">{{'From' | lang}}</label>
                      <div class="airport-code-text" *ngIf="flightForm.get('from')?.value">{{ flightForm.get('from')?.value }}</div>
                      <div class="form-group-icon">
                        <input type="text" name="from-destination" class="form-control swap-from"
                          placeholder="{{'Enter Airport' | lang}}" (keyup)="onAirportChange($event, 'from')"
                          (focus)="onFromFocus($event, 'from')" [matAutocomplete]="autoFrom" matInput
                          formControlName="ui_From">
                        <i class="fal fa-plane-departure" *ngIf="!flightForm.get('from')?.value"></i>
                      </div>
                      <div class="popular-box" *ngIf="showFromPopular && popularDestinations.length">
                        <label class="popular-title">{{'POPULAR OPTIONS' | lang}}</label>
                        <span class="close-icon">
                          <i class="fa fa-times" (click)="showFromPopular = false"></i>
                        </span>
                        <div class="popular-grid">
                          <div class="popular-item" *ngFor="let item of popularDestinations"
                            (click)="selectPopular(item, 'from')">
                            {{ item.CityName | lang }}
                          </div>
                        </div>
                      </div>
                      <mat-autocomplete #autoFrom="matAutocomplete" [displayWith]="displayFn" panelClass="airport-panel"
                        (optionSelected)="selectAirport($event.option.value, 'from')">
                        <!-- Main + Nearby grouped -->
                        <ng-container *ngFor="let group of groupedAirports">
                          <!-- ✈️ Main Airport -->
                          <mat-option [value]="group.main" class="main-airport">
                            <div class="airport-main">
                              <div class="airport-info">
                                <div class="airport-city">{{ group.main.cityName | lang }}</div>
                                <div class="airport-name">{{ group.main.airportName | lang }}</div>
                              </div>
                              <div class="airport-code">{{ group.main.airportCode }}</div>
                            </div>

                            <div *ngIf="group.nearby?.length" class="nearby-summary">
                              {{ group.nearby.length }} Nearby Airport{{ group.nearby.length > 1 ? 's' : '' }} found
                              <span class="distance-range">| within 200 km</span>
                            </div>
                          </mat-option>

                          <!-- 🟢 Nearby Airports -->
                          <mat-option *ngFor="let near of group.nearby" [value]="near" class="nearby-airport">
                            <div class="airport-nearby">
                              <div class="airport-info">
                                <div class="airport-name">{{ near.airportName | lang }}</div>
                                <div class="distance">
                                  {{ near.distanceKm }} km from {{ group.main.cityName | lang }}
                                </div>
                              </div>
                              <div class="airport-code">{{ near.airportCode }}</div>
                            </div>
                          </mat-option>
                        </ng-container>

                      </mat-autocomplete>

                    </div>
                    <span class="text-danger"
                      *ngIf="flightForm.get('ui_From')?.touched && flightForm.get('ui_From')?.invalid">
                      {{'Please select a valid origin airport' | lang}}.
                    </span>
                  </div>
                  <div class="col-xl-3 col-lg-6 col-md-6">
                    <div class="form-group">
                      <div class="search-form-swap" title="Swap From & To" (click)="swapFromTo()">
                        <i class="far fa-repeat"></i>
                      </div>
                      <label class="mb-0">{{'To' | lang}}</label>
                      <div class="airport-code-text" *ngIf="flightForm.get('to')?.value">{{ flightForm.get('to')?.value }}</div>
                      <div class="form-group-icon">
                        <input type="text" name="from-destination" class="form-control swap-from"
                          placeholder="{{'Enter Airport' | lang}}" (keyup)="onAirportChange($event, 'to')"
                          (focus)="onFromFocus($event, 'to')" [matAutocomplete]="autoTo" matInput
                          formControlName="ui_To">
                        <i class="fal fa-plane-arrival" *ngIf="!flightForm.get('to')?.value"></i>
                      </div>

                      <div class="popular-box" *ngIf="showToPopular && popularDestinations.length">
                        <label class="popular-title">{{'POPULAR OPTIONS' | lang}}</label>
                        <span class="close-icon">
                          <i class="fa fa-times" (click)="showToPopular = false"></i>
                        </span>
                        <div class="popular-grid">
                          <div class="popular-item" *ngFor="let item of popularDestinations"
                            (click)="selectPopular(item, 'to')">
                            {{ item.CityName | lang }}
                          </div>
                        </div>
                      </div>

                      <mat-autocomplete #autoTo="matAutocomplete" [displayWith]="displayFn" panelClass="airport-panel"
                        (optionSelected)="selectAirport($event.option.value, 'to')">
                        <!-- Main + Nearby grouped -->
                        <ng-container *ngFor="let group of groupedAirports">
                          <!-- ✈️ Main Airport -->

                          <mat-option [value]="group.main" class="main-airport">
                            <div class="airport-main">
                              <div class="airport-info">
                                <div class="airport-city">{{ group.main.cityName | lang }}</div>
                                <div class="airport-name">{{ group.main.airportName | lang }}</div>
                              </div>
                              <div class="airport-code">{{ group.main.airportCode }}</div>
                            </div>

                            <div *ngIf="group.nearby?.length" class="nearby-summary">
                              {{ group.nearby.length }} Nearby Airport{{ group.nearby.length > 1 ? 's' : '' }} found
                              <span class="distance-range">| within 200 {{'km' | lang}}</span>
                            </div>
                          </mat-option>

                          <!-- 🟢 Nearby Airports -->
                          <mat-option *ngFor="let near of group.nearby" [value]="near" class="nearby-airport">
                            <div class="airport-nearby">
                              <div class="airport-info">
                                <div class="airport-name">{{ near.airportName | lang }}</div>
                                <div class="distance">
                                  {{ near.distanceKm }} km from {{ group.main.cityName | lang }}
                                </div>
                              </div>
                              <div class="airport-code">{{ near.airportCode }}</div>
                            </div>
                          </mat-option>
                        </ng-container>

                      </mat-autocomplete>
                      <p>
                      </p>
                    </div>
                    <span class="text-danger" *ngIf="flightForm.get('ui_To')?.invalid">
                      {{'Please select a valid destination airport' | lang}}.
                    </span>
                  </div>
                  <div class="col-xl-3 col-lg-6 col-md-12">
                    <div class="form-group">
                      <div class="search-form-date">

                        <!-- Departure Date -->
                        <div class="search-form-journey">
                          <label>{{'Departure Date' | lang}}</label>
                          <div class="form-group-icon">
                            <input matInput [matDatepicker]="journeyPicker" placeholder="{{'Departure Date' | lang}}"
                              [min]="today" class="form-control" [value]="journeyDate" readonly
                              (click)="journeyPicker.open()" (dateChange)="onDateChange($event,0,'departureDate')"
                              formControlName="ui_DepartureDate" />
                            <mat-datepicker #journeyPicker></mat-datepicker>
                            <!-- Custom icon -->
                            <i class="fal fa-calendar-days" (click)="journeyPicker.open()"></i>
                          </div>
                          <!-- <p class="journey-day-name">{{ journeyDate }}</p> -->
                        </div>


                        <!-- Arrival Date -->
                        <div class="search-form-return" *ngIf="tripType === 'roundtrip'">
                          <label>{{'Return Date' | lang}}</label>
                          <div class="form-group-icon">
                            <input matInput [matDatepicker]="returnPicker" placeholder="{{'Return Date' | lang}}"
                              [min]="journeyDate || today" class="form-control" [value]="returnDate" readonly
                              (click)="returnPicker.open()" (dateChange)="onDateChange($event , 1,'returnDate')"
                              formControlName="ui_ReturnDate" />
                            <mat-datepicker #returnPicker></mat-datepicker>
                            <!-- Custom icon -->
                            <i class="fal fa-calendar-days" (click)="returnPicker.open()"></i>
                          </div>
                          <!-- <p class="return-day-name">{{ returnDayName }}</p> -->
                        </div>

                      </div>
                    </div>
                  </div>

                  <div class="col-xl-3 col-lg-6 col-md-12">
                    <div class="form-group dropdown passenger-box" data-bs-auto-close="outside">
                      <div class="passenger-class" role="menu" data-bs-toggle="dropdown">
                        <label>{{'Passenger, Class' | lang}}</label>
                        <div class="form-group-icon">
                          <div class="passenger-total">
                            <div class="passengerinn">
                              <span class="passenger-total-amount">
                                {{ totalPassengers }}
                              </span>
                              {{'Passenger' | lang}}
                            </div>
                            <span class="dividerin">/</span>
                            <p class="passenger-class-name">
                              {{ flightForm.get('cabinClass')?.value | titlecase }}
                            </p>
                          </div>
                          <i class="fal fa-user-tie-hair"></i>
                        </div>
                      </div>

                      <div class="dropdown-menu dropdown-menu-end">
                        <div class="passenger-dropdown-header">
                          <span class="dropdown-header-title">{{'Passengers & Class' | lang}}</span>
                          <button type="button" class="btn-close-passenger-dropdown" (click)="closePassengerDropdown($event)" [title]="'Close' | lang">
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                        <!-- Adults -->
                        <div class="dropdown-item">
                          <div class="passenger-item">
                            <div class="passenger-info">
                              <h6>{{'Adults' | lang}}</h6>
                              <p>{{'12+ Years' | lang}}</p>
                            </div>
                            <div class="passenger-qty">
                              <button type="button" class="minus-btn"
                                (click)="updatePassenger('adult','remove');$event.stopPropagation()">
                                <i class="far fa-minus"></i>
                              </button>
                              <input type="text" class="qty-amount passenger-adult"
                                [value]="flightForm.get('passengers.adult')?.value" readonly />
                              <button type="button" class="plus-btn"
                                (click)="updatePassenger('adult','add');$event.stopPropagation()">
                                <i class="far fa-plus"></i>
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Children -->
                        <div class="dropdown-item">
                          <div class="passenger-item">
                            <div class="passenger-info">
                              <h6>{{'Children' | lang}}</h6>
                              <p>{{'2-12 Years' | lang}}</p>
                            </div>
                            <div class="passenger-qty">
                              <button type="button" class="minus-btn"
                                (click)="updatePassenger('child','remove');$event.stopPropagation()">
                                <i class="far fa-minus"></i>
                              </button>
                              <input type="text" class="qty-amount passenger-children"
                                [value]="flightForm.get('passengers.child')?.value" readonly />
                              <button type="button" class="plus-btn"
                                (click)="updatePassenger('child','add');$event.stopPropagation()">
                                <i class="far fa-plus"></i>
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Infant -->
                        <div class="dropdown-item">
                          <div class="passenger-item">
                            <div class="passenger-info">
                              <h6>{{'Infant' | lang}}</h6>
                              <p>{{'Below 2 Years' | lang}}</p>
                            </div>
                            <div class="passenger-qty">
                              <button type="button" class="minus-btn"
                                (click)="updatePassenger('infant','remove');$event.stopPropagation()">
                                <i class="far fa-minus"></i>
                              </button>
                              <input type="text" class="qty-amount passenger-infant"
                                [value]="flightForm.get('passengers.infant')?.value" readonly />
                              <button type="button" class="plus-btn"
                                (click)="updatePassenger('infant','add');$event.stopPropagation()">
                                <i class="far fa-plus"></i>
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Cabin Class -->
                        <div class="dropdown-item">
                          <h6 class="mb-2 mt-2">{{'Cabin Class' | lang}}</h6>
                          <div class="passenger-class-info">
                            <div class="cabin-custom-dropdown" (click)="$event.stopPropagation()">
                              <div class="cabin-dropdown-trigger" (click)="toggleCabinDropdown($event)" [class.open]="isCabinDropdownOpen">
                                <span class="selected-text">{{ getCabinClassLabel(flightForm.get('cabinClass')?.value) | lang }}</span>
                                <i class="fal fa-chevron-down dropdown-arrow" [class.rotate]="isCabinDropdownOpen"></i>
                              </div>

                              <div class="cabin-options-list" *ngIf="isCabinDropdownOpen">
                                <div class="cabin-option-row"
                                  *ngFor="let opt of cabinOptions"
                                  [class.active]="flightForm.get('cabinClass')?.value === opt.value"
                                  (click)="selectCabinClass(opt.value, $event)">
                                  <span class="option-label">{{ opt.label | lang }}</span>
                                  <i class="fas fa-check check-mark" *ngIf="flightForm.get('cabinClass')?.value === opt.value"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- ===== FILTER ROW ===== -->
                        <div class="filter-strip" formGroupName="FilterOptions">
                          <!-- Airline -->
                          <div class="filter-item pill-check">
                            <input type="text" class="form-control" placeholder="{{'Enter Airline Name' | lang}}"
                              formControlName="ui_Airline" (keyup)="onAirlineChange($event)"
                              [matAutocomplete]="autoAirlineReg" matInput />
                          </div>
                          <mat-autocomplete #autoAirlineReg="matAutocomplete" [displayWith]="displayAirline"
                            panelClass="airport-panel" (optionSelected)="selectAirline($event.option.value)"
                            (click)="$event.stopPropagation()">
                            <!-- Main + Nearby grouped -->
                            <ng-container *ngFor="let airline of airlineList">
                              <!-- ✈️ Main Airport -->

                              <mat-option [value]="airline" class="main-airport">
                                <div class="airport-main">
                                  <div class="airport-info">
                                    <div class="airport-city">{{ airline.name }}</div>
                                  </div>
                                  <div class="airport-code">{{ airline.iata }}</div>
                                </div>
                              </mat-option>
                            </ng-container>

                          </mat-autocomplete>

                          <!-- Non Stop -->
                          <div class="filter-item">
                            <div class="pill-check" (click)="$event.stopPropagation()">
                              <input type="checkbox" id="nonstop_reg"
                                [checked]="flightForm.get('FilterOptions.DirectFlightOnly')?.value"
                                (change)="onDirectFlightOnlyChange($event);">
                              <label for="nonstop_reg">{{'Non Stop' | lang}}</label>
                            </div>
                          </div>

                          <!-- Separate -->
                          <!-- <div class="filter-item">
                    <div class="pill-check">
                      <input type="checkbox" id="separate" (change)="onResultTypeChange($event)">
                      <label for="separate">Separate Results</label>
                    </div>
                  </div> -->

                          <!-- flight search content end -->

                        </div>

                  </div>

                </div>
              </div>
            </div>
            <!-- MULTICITY -->
                <div class="row" *ngIf="tripType === 'multicity'" formArrayName="multiOriginDestinations">
                  <div *ngFor="let group of originDestinations.controls; let i = index" [formGroupName]="i">
                    <div class="row mt-2">
                      <!-- From -->
                      <div class="col-lg-3">
                        <div class="form-group">
                          <label class="mb-0">{{'From' | lang}}</label>
                          <div class="airport-code-text" *ngIf="group.get('from')?.value">{{ group.get('from')?.value }}</div>
                          <div class="form-group-icon">
                            <input type="text" class="form-control" placeholder="{{'Enter Airport' | lang}}"
                              (keyup)="onAirportChange($event,'from')" (focus)="onMultiFocus($event, 'from', i)"
                              [matAutocomplete]="autoFrom" matInput
                              formControlName="ui_From" />
                            <i class="fal fa-plane-departure" *ngIf="!group.get('from')?.value"></i>
                          </div>

                          <div class="popular-box" *ngIf="activeMultiPopular?.index === i && activeMultiPopular?.type === 'from' && popularDestinations.length">
                            <label class="popular-title">{{'POPULAR OPTIONS' | lang}}</label>
                            <span class="close-icon">
                              <i class="fa fa-times" (click)="activeMultiPopular = null"></i>
                            </span>
                            <div class="popular-grid">
                              <div class="popular-item" *ngFor="let item of popularDestinations"
                                (click)="selectPopular(item, 'from', i)">
                                {{ item.CityName | lang }}
                              </div>
                            </div>
                          </div>

                          <mat-autocomplete #autoFrom="matAutocomplete" [displayWith]="displayFn"
                            panelClass="airport-panel" (optionSelected)="selectAirport($event.option.value,'from', i)">

                            <!-- Main + Nearby grouped -->
                            <ng-container *ngFor="let group of groupedAirports">
                              <!-- ✈️ Main Airport -->
                              <mat-option [value]="group.main" class="main-airport">
                                <div class="airport-main">
                                  <div class="airport-info">
                                    <div class="airport-city">{{ group.main.cityName }}</div>
                                    <div class="airport-name">{{ group.main.airportName }}</div>
                                  </div>
                                  <div class="airport-code">{{ group.main.airportCode }}</div>
                                </div>

                                <div *ngIf="group.nearby?.length" class="nearby-summary">
                                  {{ group.nearby.length }} {{'Nearby Airport' | lang}}{{ group.nearby.length > 1 ? 's'
                                  : '' }} {{'found' | lang}}
                                  <span class="distance-range">| {{'within 200 km' | lang}}</span>
                                </div>
                              </mat-option>

                              <!-- 🟢 Nearby Airports -->
                              <mat-option *ngFor="let near of group.nearby" [value]="near" class="nearby-airport">
                                <div class="airport-nearby">
                                  <div class="airport-info">
                                    <div class="airport-name">{{ near.airportName }}</div>
                                    <div class="distance">
                                      {{ near.distanceKm }} km from {{ group.main.cityName }}
                                    </div>
                                  </div>
                                  <div class="airport-code">{{ near.airportCode }}</div>
                                </div>
                              </mat-option>
                            </ng-container>

                          </mat-autocomplete>
                        </div>
                      </div>

                      <!-- To -->
                      <div class="col-lg-3">
                        <div class="form-group">
                          <label class="mb-0">{{'To' | lang}}</label>
                          <div class="airport-code-text" *ngIf="group.get('to')?.value">{{ group.get('to')?.value }}</div>
                          <div class="form-group-icon">
                            <input type="text" class="form-control" placeholder="{{'Enter Airport' | lang}}"
                              (keyup)="onAirportChange($event,'to')" (focus)="onMultiFocus($event, 'to', i)"
                              [matAutocomplete]="autoTo" matInput
                              formControlName="ui_To" />
                            <i class="fal fa-plane-arrival" *ngIf="!group.get('to')?.value"></i>
                          </div>

                          <div class="popular-box" *ngIf="activeMultiPopular?.index === i && activeMultiPopular?.type === 'to' && popularDestinations.length">
                            <label class="popular-title">{{'POPULAR OPTIONS' | lang}}</label>
                            <span class="close-icon">
                              <i class="fa fa-times" (click)="activeMultiPopular = null"></i>
                            </span>
                            <div class="popular-grid">
                              <div class="popular-item" *ngFor="let item of popularDestinations"
                                (click)="selectPopular(item, 'to', i)">
                                {{ item.CityName | lang }}
                              </div>
                            </div>
                          </div>
                          <mat-autocomplete #autoTo="matAutocomplete" [displayWith]="displayFn"
                            panelClass="airport-panel" (optionSelected)="selectAirport($event.option.value,'to', i)">

                            <!-- Main + Nearby grouped -->
                            <ng-container *ngFor="let group of groupedAirports">
                              <!-- ✈️ Main Airport -->
                              <mat-option [value]="group.main" class="main-airport">
                                <div class="airport-main">
                                  <div class="airport-info">
                                    <div class="airport-city">{{ group.main.cityName }}</div>
                                    <div class="airport-name">{{ group.main.airportName }}</div>
                                  </div>
                                  <div class="airport-code">{{ group.main.airportCode }}</div>
                                </div>

                                <div *ngIf="group.nearby?.length" class="nearby-summary">
                                  {{ group.nearby.length }} {{'Nearby Airport' | lang}}{{ group.nearby.length > 1 ? 's'
                                  : '' }} {{'found' | lang}}
                                  <span class="distance-range">| {{'within 200 km' | lang}}</span>
                                </div>
                              </mat-option>

                              <!-- 🟢 Nearby Airports -->
                              <mat-option *ngFor="let near of group.nearby" [value]="near" class="nearby-airport">
                                <div class="airport-nearby">
                                  <div class="airport-info">
                                    <div class="airport-name">{{ near.airportName }}</div>
                                    <div class="distance">
                                      {{ near.distanceKm }} km from {{ group.main.cityName }}
                                    </div>
                                  </div>
                                  <div class="airport-code">{{ near.airportCode }}</div>
                                </div>
                              </mat-option>
                            </ng-container>

                          </mat-autocomplete>
                        </div>
                      </div>

                      <!-- Journey Date -->
                      <div class="col-lg-3">
                        <div class="form-group">
                          <label>{{'Departure Date' | lang}}</label>
                          <div class="form-group-icon">
                            <input matInput [matDatepicker]="journeyPicker" placeholder="{{'Departure Date' | lang}}"
                              [min]="journeyDateMulti[i-1] || today" class="form-control"
                              formControlName="departureDate" readonly (click)="journeyPicker.open()"
                              (dateChange)="onDateChange($event, i)" formControlName="departureDate" />
                            <mat-datepicker #journeyPicker></mat-datepicker>
                            <i class="fal fa-calendar-days" (click)="journeyPicker.open()"></i>
                          </div>
                        </div>
                      </div>

                      <!-- Remove Leg -->
                      <div class="col-lg-3 d-flex align-items-end" *ngIf="i >1">
                        <button type="button" class="btn btn-outline-danger" (click)="removeMultiCity(i)"
                          *ngIf="originDestinations.length > 1">
                          {{'Remove' | lang}}
                        </button>
                      </div>

                      <div class="col-lg-3" *ngIf="i ==0" [formGroup]="flightForm">
                        <div class="form-group dropdown passenger-box">
                          <div class="passenger-class" role="menu" data-bs-toggle="dropdown" aria-expanded="false">
                            <label>{{'Passenger, Class' | lang}}</label>
                            <div class="form-group-icon">
                              <div class="passenger-total">
                                <span class="passenger-total-amount">
                                  {{ totalPassengers }}
                                </span>
                                {{'Passenger' | lang}}
                              </div>
                              <i class="fal fa-user-tie-hair"></i>
                            </div>
                            <p class="passenger-class-name">
                              {{ flightForm.get('cabinClass')?.value | titlecase }}
                            </p>
                          </div>

                          <div class="dropdown-menu dropdown-menu-end">
                            <div class="passenger-dropdown-header">
                              <span class="dropdown-header-title">{{'Passengers & Class' | lang}}</span>
                              <button type="button" class="btn-close-passenger-dropdown" (click)="closePassengerDropdown($event)" [title]="'Close' | lang">
                                <i class="fa fa-times"></i>
                              </button>
                            </div>
                            <!-- Adults -->
                            <div class="dropdown-item">
                              <div class="passenger-item">
                                <div class="passenger-info">
                                  <h6>{{'Adults' | lang}}</h6>
                                  <p>{{'12+ Years' | lang}}</p>
                                </div>
                                <div class="passenger-qty">
                                  <button type="button" class="minus-btn"
                                    (click)="updatePassenger('adult','remove');$event.stopPropagation()">
                                    <i class="far fa-minus"></i>
                                  </button>
                                  <input type="text" class="qty-amount passenger-adult"
                                    [value]="flightForm.get('passengers.adult')?.value" readonly />
                                  <button type="button" class="plus-btn"
                                    (click)="updatePassenger('adult','add');$event.stopPropagation()">
                                    <i class="far fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Children -->
                            <div class="dropdown-item">
                              <div class="passenger-item">
                                <div class="passenger-info">
                                  <h6>{{'Children' | lang}}</h6>
                                  <p>{{'2-12 Years' | lang}}</p>
                                </div>
                                <div class="passenger-qty">
                                  <button type="button" class="minus-btn"
                                    (click)="updatePassenger('child','remove');$event.stopPropagation()">
                                    <i class="far fa-minus"></i>
                                  </button>
                                  <input type="text" class="qty-amount passenger-children"
                                    [value]="flightForm.get('passengers.child')?.value" readonly />
                                  <button type="button" class="plus-btn"
                                    (click)="updatePassenger('child','add');$event.stopPropagation()">
                                    <i class="far fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Infant -->
                            <div class="dropdown-item">
                              <div class="passenger-item">
                                <div class="passenger-info">
                                  <h6>{{'Infant' | lang}}</h6>
                                  <p>{{'Below 2 Years' | lang}}</p>
                                </div>
                                <div class="passenger-qty">
                                  <button type="button" class="minus-btn"
                                    (click)="updatePassenger('infant','remove');$event.stopPropagation()">
                                    <i class="far fa-minus"></i>
                                  </button>
                                  <input type="text" class="qty-amount passenger-infant"
                                    [value]="flightForm.get('passengers.infant')?.value" readonly />
                                  <button type="button" class="plus-btn"
                                    (click)="updatePassenger('infant','add');$event.stopPropagation()">
                                    <i class="far fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Cabin Class -->
                            <div class="dropdown-item">
                              <h6 class="mb-2 mt-2">{{'Cabin Class' | lang}}</h6>
                              <div class="passenger-class-info">
                                <div class="cabin-custom-dropdown" (click)="$event.stopPropagation()">
                                  <div class="cabin-dropdown-trigger" (click)="toggleCabinDropdown($event)" [class.open]="isCabinDropdownOpen">
                                    <span class="selected-text">{{ getCabinClassLabel(flightForm.get('cabinClass')?.value) | lang }}</span>
                                    <i class="fal fa-chevron-down dropdown-arrow" [class.rotate]="isCabinDropdownOpen"></i>
                                  </div>

                                  <div class="cabin-options-list" *ngIf="isCabinDropdownOpen">
                                    <div class="cabin-option-row"
                                      *ngFor="let opt of cabinOptions"
                                      [class.active]="flightForm.get('cabinClass')?.value === opt.value"
                                      (click)="selectCabinClass(opt.value, $event)">
                                      <span class="option-label">{{ opt.label | lang }}</span>
                                      <i class="fas fa-check check-mark" *ngIf="flightForm.get('cabinClass')?.value === opt.value"></i>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- ===== FILTER ROW ===== -->
                            <div class="filter-strip" formGroupName="FilterOptions">
                              <!-- Airline -->
                              <div class="filter-item pill-check">
                                <input type="text" class="form-control" placeholder="{{'Enter Airline Name' | lang}}"
                                  formControlName="ui_Airline" (keyup)="onAirlineChange($event)"
                                  [matAutocomplete]="autoAirlineMulti" matInput />
                              </div>
                              <mat-autocomplete #autoAirlineMulti="matAutocomplete" [displayWith]="displayAirline"
                                panelClass="airport-panel" (optionSelected)="selectAirline($event.option.value)"
                                (click)="$event.stopPropagation()">
                                <!-- Main + Nearby grouped -->
                                <ng-container *ngFor="let airline of airlineList">
                                  <!-- ✈️ Main Airport -->

                                  <mat-option [value]="airline" class="main-airport">
                                    <div class="airport-main">
                                      <div class="airport-info">
                                        <div class="airport-city">{{ airline.name }}</div>
                                      </div>
                                      <div class="airport-code">{{ airline.iata }}</div>
                                    </div>
                                  </mat-option>
                                </ng-container>

                              </mat-autocomplete>

                              <!-- Non Stop -->
                              <div class="filter-item">
                                <div class="pill-check" (click)="$event.stopPropagation()">
                                  <input type="checkbox" id="nonstop_multi"
                                    [checked]="flightForm.get('FilterOptions.DirectFlightOnly')?.value"
                                    (change)="onDirectFlightOnlyChange($event);">
                                  <label for="nonstop_multi">{{'Non-Stop' | lang}}</label>
                                </div>
                              </div>

                              <!-- Separate -->
                              <!-- <div class="filter-item">
                    <div class="pill-check">
                      <input type="checkbox" id="separate" (change)="onResultTypeChange($event)">
                      <label for="separate">{{'Separate Results' | lang}}</label>
                    </div>
                  </div> -->

                              <!-- flight search content end -->

                            </div>

                          </div>
                        </div>
                      </div>

                    </div>
                  </div>



                  <!-- Add More Legs -->
                  <div class="col-lg-12 mt-2" *ngIf="originDestinations.controls.length <=4">
                    <button type="button" class="btn btn-outline-primary" (click)="MultiCityAdd()">
                      + {{'Add City' | lang}}
                    </button>
                  </div>
                </div>

                <!-- <div class="row">
                  <div class="col-lg-2" (click)="openFilter()">
                    <div class="filter-header">
                      <h6>{{'Filter Options' | lang}}</h6>
                    </div>
                  </div>
                </div> -->

                <!-- Supplier Checklist -->
                <div class="supplier-list-wrapper mt-3 pt-2 border-top" *ngIf="showSupplierToAgency == 'True' && suppliers && suppliers.length">
                  <div class="d-flex align-items-center mb-2 flex-wrap">
                    <label class="mb-0 font-weight-bold me-3" style="font-size: 13px; color: #475569;">{{'Suppliers' | lang}}</label>
                    <div class="form-check m-0 me-3">
                      <input class="form-check-input" type="checkbox" id="supplier-select-all"
                        [checked]="isAllSuppliersSelected()"
                        (change)="toggleSelectAllSuppliers($event)">
                      <label class="form-check-label ms-1" for="supplier-select-all" style="font-size: 12px; cursor: pointer; font-weight: 500; color: #475569;">
                        {{'Select All' | lang}}
                      </label>
                    </div>
                  </div>
                  <div class="d-flex flex-wrap gap-2">
                    <div class="form-check form-check-inline m-0 me-3 mb-1" *ngFor="let supplier of suppliers">
                      <input class="form-check-input" type="checkbox"
                        [id]="'supplier-bottom-' + supplier.SupplierId"
                        [checked]="selectedSupplierCodes.includes(supplier.SupplierCode)"
                        (change)="onSupplierChange(supplier.SupplierCode, $event)">
                      <label class="form-check-label ms-1" [for]="'supplier-bottom-' + supplier.SupplierId" style="font-size: 13px; cursor: pointer; color: #1e293b;">
                        {{ supplier.SupplierName }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="search-btn">
                <button type="submit" class="theme-btn" [disabled]="loading">
                  <span *ngIf="!loading" class="far fa-search"></span>
                  <span *ngIf="loading" class="spinner-border spinner-border-sm"></span>
                  {{ loading ? ('Searching...' | lang) : ('Search Now' | lang) }}
                </button>
              </div>
            </div>
          </div>
          <!-- flight search end -->
        </form>
      </div>
    </div>
  </div>
</div>
